import styled from "styled-components"

export const Card = styled.div`
  border-radius: 13px;
  border: 1px solid #e4e4e4;
  background: #fff;
  margin: 20px;
  flex-direction: column;
  padding-bottom: 20px;
  box-sizing: border-box;
  overflow: hidden;
  @media (max-width: 991.98px) {
    margin: 7px;
  }
`

export const Details = styled.div`
  border-radius: 13px;
  border: 2px solid #e4e4e4;
  box-sizing: border-box;
  overflow: hidden;
`

export const Header = styled.div`
  margin: 1rem 1rem 1rem 1.5rem;
  display: flex;
  height: 25px;
  width: 100%;
`

export const Title = styled.h2`
  font-weight: 700;
  font-size: 20px;
  flex: none;
  color: #545454;
  font-weight: 400;
  line-height: 1.5;
`

export const Divider = styled.div`
  color: #e4e4e4;
  margin: 0.5rem 0 0 0.5rem;
  width: 100%;
  border-bottom: 1px #e4e4e4 solid;
`
